import { Button, CircularProgress, Modal, Stack, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { BIBlack, BIGrey } from "../../../assets/helpers";
import { LoadingButton } from "@mui/lab";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

function DeletConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Are you sure you want to delete this client?",
  heading = "The hours you logged will also be deleted.",
  loading = false,
  headingCenter = false
}) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const { TEXT_GO_BACK, TEXT_DELETE } = ClientEnglishFallback?.DeletConfirmModal(
    multiLanguageData?.DeletConfirmModal || {}
  );
  return (
    <Modal open={isOpen} onClose={onClose}>
      <div
        className="client-modal-responsive"
        style={{
          width: "auto"
        }}>
        <Typography sx={{ fontWeight: 600 }} textAlign={"center"}>
          {heading}
        </Typography>
        <Typography sx={{ mb: 1, color: BIGrey }}>
          {title}
        </Typography>
        <Stack direction={"row"} sx={{ justifyContent: "space-between" }} spacing={1}>
          <Button
            disabled={loading}
            sx={{
              textTransform: "none",
              backgroundColor: "#e4e4e4",
              borderRadius: "10px",
              color: BIBlack
            }}
            onClick={onClose}
            fullWidth>
            {TEXT_GO_BACK}
          </Button>
          <LoadingButton
            loading={loading}
            loadingPosition="start"
            startIcon={<></>}
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              backgroundColor: loading ? "#e4e4e4" : selectedClientData?.AccentColor,
              color: "#fff"
            }}
            onClick={onConfirm}
            fullWidth>
            {TEXT_DELETE}
          </LoadingButton>
        </Stack>
      </div>
    </Modal>
  );
}

export default DeletConfirmModal;
